import { breakpointNames, breakpointsDictMap, firstBreakpointName } from '../../css/breakpoints';

const isResponsiveArray = value => Array.isArray(value);

const isResponsiveScalar = value => typeof value !== 'object';

export const getValueByBreakpointFromResponsiveProps = (b, value) => {
  if (isResponsiveScalar(value)) {
    return value;
  }

  if (isResponsiveArray(value)) {
    return value[breakpointNames.indexOf(b)] || undefined;
  }

  return value[b] || undefined;
};
export const resolveResponsiveProp = (value, atoms) => {
  if (typeof value !== 'object') {
    return atoms[firstBreakpointName][value];
  }

  return breakpointNames.map(b => {
    const v = getValueByBreakpointFromResponsiveProps(b, value);
    return typeof v === 'undefined' ? '' : atoms[b][v];
  }).join(' ');
};
export const resolveResponsivePropSafe = (value, atoms) => {
  if (typeof value === 'undefined') {
    return false;
  }

  return resolveResponsiveProp(value, atoms);
}; // return a map with all the breakpoints
// but it uses the previous breakpoint if the one selected is undefined

export function normalizeResponsiveProp(v) {
  let lastValidBreakpoint;
  return breakpointsDictMap(b => {
    const value = getValueByBreakpointFromResponsiveProps(b, v);

    if (value) {
      lastValidBreakpoint = value;
      return value;
    }

    return lastValidBreakpoint;
  });
}
//# sourceMappingURL=responsiveProp.js.map